
























import { defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { BrandsType } from '~/constants/brands';
import { useBrandPage } from '~/composables';
import Button from '~/components/atoms/Buttons/Button/Button.vue';
import BrandImage from '~/components/molecules/Product/Brand/BrandImage/BrandImage.vue';

export default defineComponent({
  name: 'AboutTheBrand',
  components: {
    Button,
    BrandImage,
  },
  props: {
    brand: {
      type: Object as PropType<BrandsType>,
      required: true,
    },
  },
  setup(props) {
    const { getBrandPageUrl } = useBrandPage();
    const brandPage = getBrandPageUrl(props.brand.name);

    return {
      brandPage,
    };
  },
});
